import * as nd from 'nd4js';

export const mean_axis = (src) => {
  // Mean Over Src
  let src_mean_x = 0;
  let src_mean_y = 0;

  for (let i = 0; i < src.shape[0]; i++) {
    src_mean_y += src(i, 0);
    src_mean_x += src(i, 1);
  }

  src_mean_y /= src.shape[0];
  src_mean_x /= src.shape[0];
  return nd.array([[src_mean_y, src_mean_x]]);
};

export const getSimilarityTransformation = (landmarks, transformation, factor = 1) => {
  let src = nd.array([
    [landmarks[0][0], landmarks[0][1]],
    [landmarks[1][0], landmarks[1][1]],
    [landmarks[2][0], landmarks[2][1]],
    [landmarks[3][0], landmarks[3][1]],
    [landmarks[4][0], landmarks[4][1]],
    [landmarks[5][0], landmarks[5][1]],
  ]);
  src = nd.zip_elems([src, factor], (x, y) => x * y);

  let dst = nd.array([
    [transformation[0], transformation[1]],
    [transformation[2], transformation[3]],
    [transformation[4], transformation[5]],
    [transformation[6], transformation[7]],
    [transformation[8], transformation[9]],
    [transformation[10], transformation[11]],
  ]);
  let estimate_scale = true;
  let num = src.shape[0];
  let dim = src.shape[1];
  let src_mean = mean_axis(src);
  let dst_mean = mean_axis(dst);
  const src_demean = nd.zip_elems([src, src_mean], (x, y) => x - y);
  const dst_demean = nd.zip_elems([dst, dst_mean], (x, y) => x - y);
  let A = nd.zip_elems([nd.la.matmul(dst_demean.T, src_demean), num], (x, y) => x / y);
  let det_A = nd.la.det(A);
  let d = new Array(dim).fill(1);

  if (det_A < 0) {
    d[dim - 1] = -1;
  }

  let svd_return = nd.la.svd_decomp(A);
  let U = svd_return[0];
  let S = svd_return[1];
  let V = svd_return[2];
  let rank_A = nd.la.rank(A);

  let T = nd.la.eye(dim + 1);
  let rT, tT;

  switch (rank_A) {
    case 0: {
      return -1;
    }
    case dim - 1: {
      if (nd.la.det(U) * nd.la.det(V) > 0) {
        rT = nd.la.matmul(U, V);
        // Python Code (Not Checked)
        // T[:dim, :dim] = U @ V
      } else {
        let _d = new Array(dim).fill(1);
        _d[dim - 1] = -1;
        rT = nd.la.matmul(U, nd.la.diag_mat(_d), V);
        // Python Code (Not Checked)
        // s = d[dim - 1]
        // d[dim - 1] = -1
        // T[:dim, :dim] = U @ np.diag(d) @ V
        // d[dim - 1] = s
      }
      break;
    }
    default: {
      rT = nd.la.matmul(U, nd.la.diag_mat(d), V);
      break;
    }
  }

  let scale = 1.0;
  if (estimate_scale) {
    let _v_sum = mean_axis(nd.zip_elems([src_demean], (x) => x * x)).data.reduce((a, b) => a + b);
    scale = nd.la.matmul(nd.array([S.data]), nd.array([d]).T).data[0] / _v_sum;
    // Python Code
    // scale = 1.0 / src_demean.var(axis=0).sum() * (S @ d)
  }

  rT = nd.zip_elems([rT, scale], (x, y) => x * y);
  tT = nd.zip_elems([dst_mean, nd.la.matmul(rT, src_mean.T).T], (x, y) => x - y);

  for (let i = 0; i < dim; i++) {
    for (let j = 0; j < dim; j++) {
      T.set([i, j], rT(i, j));
    }
  }

  for (let i = 0; i < dim; i++) {
    T.set([i, dim], tT(0, i));
  }

  // Python Code
  // T[:dim, dim] = dst_mean - scale * (T[:dim, :dim] @ src_mean.T)
  // T[:dim, :dim] *= scale

  // console.log(T.toString());
  return T;
};
